import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=55aa7862&scoped=true"
import script from "./CopyRight.vue?vue&type=script&lang=ts"
export * from "./CopyRight.vue?vue&type=script&lang=ts"
import style0 from "./CopyRight.vue?vue&type=style&index=0&id=55aa7862&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa7862",
  null
  
)

export default component.exports